<template>
  <div v-if="rejected" class="rounded-md bg-red-50 p-4">
    <div class="flex">
      <div class="flex-shrink-0">
        <svg
          xmlns="http://www.w3.org/2000/svg"
          class="h-5 w-5 text-red-400"
          viewBox="0 0 20 20"
          fill="currentColor"
        >
          <path
            fill-rule="evenodd"
            d="M10 18a8 8 0 100-16 8 8 0 000 16zM8.707 7.293a1 1 0 00-1.414
              1.414L8.586 10l-1.293 1.293a1 1 0 101.414 1.414L10 11.414l1.293
              1.293a1 1 0 001.414-1.414L11.414 10l1.293-1.293a1 1 0
              00-1.414-1.414L10 8.586 8.707 7.293z"
            clip-rule="evenodd"
          />
        </svg>
      </div>
      <div class="ml-3">
        <h3 class="text-sm font-medium text-red-800">
          {{ rejectReason }}
        </h3>
      </div>
    </div>
  </div>
  <button
    v-else
    class="inline-flex items-center text-white px-3 py-1 text-sm rounded-sm bg-blue-600 hover:bg-blue-700 hover:text-white transition-colors duration-150 focus:outline-none"
    @click="subscribe"
  >
    <svg
      v-if="loading"
      class="animate-spin h-4 w-4 mr-2 text-white inline-flex"
      xmlns="http://www.w3.org/2000/svg"
      fill="none"
      viewBox="0 0 24 24"
    >
      <circle class="opacity-25" cx="12" cy="12" r="10" stroke="currentColor" stroke-width="4" />
      <path
        class="opacity-75"
        fill="currentColor"
        d="M4 12a8 8 0 018-8V0C5.373 0 0 5.373 0 12h4zm2 5.291A7.962 7.962
          0 014 12H0c0 3.042 1.135 5.824 3 7.938l3-2.647z"
      />
    </svg>
    <span class="inline-block">Subscribe</span>
  </button>
</template>

<script>
export default {
  props: {
    pageId: {
      type: [String, Number],
      required: true,
    },
  },
  data() {
    return {
      loading: false,
      rejected: false,
      rejectReason: 'Something went wrong!',
    };
  },
  methods: {
    setLoading(loading) {
      this.loading = loading;
    },
    setRejected(rejected) {
      this.rejected = rejected;
    },
    async subscribe() {
      if (this.loading) {
        return;
      }

      this.setLoading(true);

      try {
        const formData = new FormData();
        formData.append('page_id', this.pageId);

        await this.$store.dispatch('admin/subscribedFacebookPages/store', { page_id: this.pageId });

        this.$emit('subscribe');
      } catch (error) {
        if (error?.response?.data) {
          this.rejectReason = error.response.data.message;
        } else {
          this.rejectReason = error.message;
        }

        this.setRejected(true);
      } finally {
        this.setLoading(false);
      }
    },
  },
};
</script>
